<template>
  <el-dialog
    title="下发通知消息"
    :modal-append-to-body="false"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancelForm"
    :visible.sync="actionDataBox"
    width="40%"
  >
    <div class="dialog_box">
      <el-form ref="ruleForm" :rules="rules" :model="actionDataInfo" label-width="0px">
        <div class="form-row-item-box">
          <div class="form-item-box">
            <span>标题:</span>
            <el-form-item prop="headline">
              <el-input
                size="small"
                clearable
                style="width: 100%"
                v-model.trim="actionDataInfo.headline"
              ></el-input>
            </el-form-item>
          </div>
          <div class="form-row-item-box">
            <div class="form-item-box" style="width: 100%">
              <span>通知内容:</span>
              <el-form-item prop="message">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  placeholder="请输入内容"
                  v-model="actionDataInfo.message"
                >
                </el-input>

                <!-- <vue-ueditor-wrap
                  v-model="actionDataInfo.message"
                  :config="config"
                  ref="ueditor"
                ></vue-ueditor-wrap> -->
              </el-form-item>
            </div>
          </div>
          <div class="form-item-box" v-if="addType == 'edu'">
            <span>发送机构:</span>
            <el-form-item prop="projectIds">
              <tree-common
                ref="eduTreeCommon"
                :treeData="eduList"
                style="width: 100%"
              ></tree-common>
              <!-- <el-cascader
                ref="cascader"
                size="small"
                :props="props"
                @change="selectEdu"
              ></el-cascader> -->
              <!-- <el-input
                v-if="isEditSatus"
                size="small"
                disabled
                style="width: 100%"
                v-model.trim="actionDataInfo.parEduName"
              ></el-input>
              <edu-select
                v-else
                v-model="actionDataInfo.parEduId"
                :isEditSatus="isEditSatus"
                :addResize="addResize"
              ></edu-select> -->
            </el-form-item>
          </div>
          <div class="form-item-box" v-if="addType == 'school'">
            <span>发送学校:</span>
            <el-form-item prop="projectIds">
              <tree-common
                ref="treeCommon"
                :treeData="schoolList"
                style="width: 100%"
              ></tree-common>
            </el-form-item>
          </div>
        </div>
        <!-- <div class="form-row-item-box">
          <div class="form-item-box" style="width: 100%">
            <span>下发类型:</span>
            <el-form-item prop="inspectionTeamIds">
              <el-radio
                size="small"
                v-model="actionDataInfo.identification"
                :label="1"
                border
                >教育局</el-radio
              >
              <el-radio
                size="small"
                v-model="actionDataInfo.identification"
                :label="2"
                border
                >学校</el-radio
              >
            </el-form-item>
          </div>
        </div> -->
      </el-form>
      <div class="dialog_save_cancel_box">
        <div class="cancel_item_box" @click="cancelForm">取消</div>
        <div class="save_item_box" @click="saveClick('ruleForm')">确定</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
// let id = 0;
import TreeCommon from "@/components/TreeCommon";
import eduSelect from "./eduSelect";
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  name: "",
  components: {
    TreeCommon,
    eduSelect,
    VueUeditorWrap,
  },
  props: {
    addResize: {
      type: Number,
      default: {
        return: 0,
      },
    },
    addType: {
      type: String,
      default: {
        return: "",
      },
    },
  },
  data() {
    return {
      eduInfo: JSON.parse(sessionStorage.getItem("eduInfo")),
      isEditSatus: false,
      actionDataBox: false,
      rules: {
        headline: [{ required: true, message: " ", trigger: "blur" }],
        message: [{ required: true, message: " ", trigger: "blur" }],
        organizationList: [
          { type: "array", required: true, message: " ", trigger: "change" },
        ],
        identification: [{ required: true, message: " ", trigger: "blur" }],
      },
      config: {
        // 相对路径
        UEDITOR_HOME_URL: "/UEditor/",
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度// 初始容器宽度
        initialFrameHeight: 300,
        initialFrameWidth: "100%",
        toolbars: [
          [
            "fullscreen",
            "source",
            "|",
            "undo",
            "redo",
            "|",
            "bold",
            "italic",
            "underline",
            "fontborder",
            "strikethrough",
            "superscript",
            "subscript",
            "removeformat",
            "formatmatch",
            "blockquote",
            "pasteplain",
            "|",
            "forecolor",
            "backcolor",
            "insertorderedlist",
            "insertunorderedlist",
            "selectall",
            "cleardoc",
            "|",
            "rowspacingtop",
            "rowspacingbottom",
            "lineheight",
            "|",
            "customstyle",
            "paragraph",
            "fontfamily",
            "fontsize",
            "|",
            "directionalityltr",
            "directionalityrtl",
            "indent",
            "|",
            "justifyleft",
            "justifycenter",
            "justifyright",
            "justifyjustify",
            "|",
            "touppercase",
            "tolowercase",
            "|",
            "link",
            "unlink",
            "anchor",
            "|",
            "imagenone",
            "imageleft",
            "imageright",
            "imagecenter",
            "|",
            "simpleupload",
            "insertimage",
            "|",
            "horizontal",
            "date",
            "time",
            "spechars",
            "snapscreen",
            "|",
            "inserttable",
            "deletetable",
            "insertparagraphbeforetable",
            "insertrow",
            "deleterow",
            "insertcol",
            "deletecol",
            "mergecells",
            "mergeright",
            "mergedown",
            "splittocells",
            "splittorows",
            "splittocols",
            "charts",
          ],
        ],
        // 不显示字数
        // wordCount: false,
        enableAutoSave: true, //自动保存
        // 上传图片路径,需要后台配置，否则控制台会报错。
        // 报错信息为 后台配置项返回格式出错，上传功能将不能正常使用！
        // serverUrl: "http://35.201.165.105:8000/controller.php",
      },
      props: {
        lazy: true,
        multiple: true,
        lazyLoad: async (node, resolve) => {
          const { level } = node;
          // console.log(node, resolve, 111);
          // let eduId;
          let data;
          if (node.level == 0) {
            let eduId = this.$store.getters.getEduData.eduId;
            let eduName = this.$store.getters.getEduData.eduBuresuName;
            data = [
              {
                eduId: eduId,
                eduName: eduName,
                children: [],
              },
            ];
          } else {
            let eduId = node.value;
            data = await this.getSubEduList(eduId);
            // console.log(data);
          }
          let nodes = data.map((item) => ({
            value: item.eduId,
            label: item.eduName,
            children: [], // leaf: level >= 2,
          }));
          // setTimeout(() => {
          //   const nodes = Array.from({ length: level + 1 }).map((item) => ({
          //     value: ++id,
          //     label: `选项${id}`,
          //     leaf: level >= 2,
          //   }));
          //   // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(nodes);
          // }, 1000);
        },
      },
      actionDataInfo: {
        headline: "",
        message: "",
        organizationList: [],
        senderName: this.$store.getters.getEduData.eduBuresuName,
        senderId: this.$store.getters.getEduData.eduId,
        identification: 1,
        parEduId: "",
      },
      schoolList: [],
      eduList: [],
    };
  },
  watch: {
    addResize: function (newVal) {
      if (newVal) {
        // let eduId = this.$store.getters.getEduData.eduId;
        // this.getSubEduList(eduId);
        this.clearData();
        if (this.addType == "school") {
          this.actionDataInfo.identification = 2;
          this.getEducationBureau();
        } else {
          this.actionDataInfo.identification = 1;
          this.getEduList();
        }
        this.actionDataBox = true;
      }
    },
  },
  computed: {},
  methods: {
    clearData() {
      this.actionDataInfo = {
        headline: "",
        message: "",
        organizationList: [],
        senderName: this.$store.getters.getEduData.eduBuresuName,
        senderId: this.$store.getters.getEduData.eduId,
        identification: 1,
      };
    },
    openAddBox() {
      this.actionDataBox = true;
      setTimeout(() => {
        this.$refs.ruleForm.resetFields();
      }, 100);
    },
    cancelForm() {
      this.actionDataBox = false;
      this.$refs.ruleForm.resetFields();
      this.clearData();
    },
    saveClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addType == "school") {
            this.actionDataInfo.organizationList = this.removeArr(
              this.$refs.treeCommon.$refs.tree.getCheckedKeys(),
              "00"
            );
            if (this.actionDataInfo.organizationList.length == 0) {
              this.$message("请选择发送学校！");
              return;
            }
          } else {
            this.actionDataInfo.organizationList = this.removeArr(
              this.$refs.eduTreeCommon.$refs.tree.getCheckedKeys(),
              "00"
            );
            if (this.actionDataInfo.organizationList.length == 0) {
              this.$message("请选择发送机构！");
              return;
            }
          }
          this.sendEduNotices();
        } else {
          return false;
        }
      });
    },
    removeArr(arr, item) {
      let newArr = [];
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] !== item) {
          newArr.push(arr[i]);
        }
      }
      return newArr;
    },
    async sendEduNotices() {
      let req = this.actionDataInfo;
      let res = await this.$Http.sendEduNotices(req);
      if (res.code == 200) {
        this.actionDataBox = false;
        this.$message({
          message: "发送成功！",
          type: "success",
        });
        this.$emit("addList");
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error",
        });
      }
    },
    selectEdu() {
      let nodesObj = this.$refs["cascader"].getCheckedNodes(true);
      // console.log(nodesObj, 222);
    },
    async getSubEduList(id) {
      let req = {
        eduId: id,
      };
      let res = await this.$Http.getRegionList(req);
      if (res.code == 200) {
        // console.log(res.data);
        return res.data;
        // this.resData.pageSize = res.data.pageSize;
        // this.resData.pageNum = res.data.pageNum;
        // this.resData.total = res.data.total;
        // this.resData.pages = res.data.pages;
        // this.resData.list = res.data.list;
      } else if (res.code == 101) {
        return [];
      } else {
        console.log(res.messsage);
        return [];
        // this.$message({
        //   message: res.messsage,
        //   type: "error",
        // });
      }
    },
    async getEduList() {
      let req = {
        eduId: this.eduInfo.eduId,
      };
      let res = await this.$Http.getSubordinateEdu(req);
      if (res.code == 200) {
        if (res.code == 200) {
          let data = res.data || [];
          let newData = data.map((item) => {
            let obj = {
              label: item.eduBuresuName || "",
              id: item.eduId || "",
              leve: "2",
            };
            return obj;
          });
          if (data.length > 0) {
            this.eduList = [
              {
                label: "全部",
                id: "00",
                leve: "1",
                children: newData,
              },
            ];
          }
        } else if (res.code == 101) {
          this.eduList = [];
        } else {
          this.eduList = [];
          this.$message({
            message: res.messsage || "下属学校查询失败",
            type: "error",
          });
        }
      }
    },
    async getEducationBureau() {
      let req = {
        parEduId: this.eduInfo.eduId,
      };
      let res = await this.$Http.getEducationBureau(req);
      if (res.code == 200) {
        let data = res.data || [];
        let newData = data.map((item) => {
          let obj = {
            label: item.schoolName || "",
            id: item.schoolId || "",
            leve: "2",
          };
          return obj;
        });
        if (data.length > 0) {
          this.schoolList = [
            {
              label: "全部",
              id: "00",
              leve: "1",
              children: newData,
            },
          ];
        }
      } else if (res.code == 101) {
        this.schoolList = [];
      } else {
        this.schoolList = [];
        this.$message({
          message: res.messsage || "下属学校查询失败",
          type: "error",
        });
      }
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped lang="scss">
.dialog_save_cancel_box {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 20px;
  .cancel_item_box {
    width: 85px;
    height: 30px;
    border-radius: 16px 4px 16px 4px;
    border: 1px solid #d4e8f5;
    color: rgba(173, 174, 198, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: transform 0.3s;
    &:hover {
      transform: scale(1.1);
    }
  }
  .save_item_box {
    margin-left: 10px;
    width: 85px;
    height: 30px;
    background: #41a4f1;
    border-radius: 16px 4px 16px 4px;
    color: rgba(255, 255, 255, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: transform 0.3s;
    &:hover {
      transform: scale(1.1);
    }
  }
}
</style>
